import { ShimmerTitleText } from '@chegg-ui/shimmer';
import styled from 'styled-components';
export var ShimmerTitleTextSC = styled(ShimmerTitleText).withConfig({
  componentId: "sc-1p74u7y-0"
})(["width:", ";"], function (_ref) {
  var width = _ref.width;
  return "".concat(width, "%");
});